<template>
  <div class="timeDiv">
    <div class="cont1">
      <div class="left">预约时间<span style="color: red;">*</span></div>
      <div
        :style="
          timeValue == '请选择预约时间'
            ? 'flex: 2.1;color: #c8c9cc;'
            : 'flex: 2.1;'
        "
        @click="timeShow = true"
      >
        {{ timeValue }}
      </div>
      <div class="right" @click="timeShow = true">
        <van-icon name="notes-o" style="line-height: 50px;" color="#b2b2b2" />
      </div>
    </div>
    <van-calendar
      v-model="timeShow"
      color="#009967"
      @confirm="onConfirmTime"
      row-height="58"
      :show-title="false"
      :round="false"
    />

    <div v-if="timeValue !== '请选择预约时间'">
      <div class="cont2">
        <div class="cont2-first">时间段</div>
        <div>预约上限</div>
        <div>可预约数</div>
        <div style="flex: 0.1"></div>
      </div>
      <div
        :class="item.surplus === 0 ? 'cont3 bg456' : 'cont3'"
        v-for="(item, index) in hongtaTime"
        :key="index"
        @click="changeAppointTime(item, 'hongtaTime')"
      >
        <div class="cont3-first">{{ item.name }}</div>
        <div class="cont3-second">{{ item.limit }}</div>
        <div
          class="cont3-third"
          :style="item.surplus === 0 ? 'color: #666666' : ''"
        >
          <span v-if="item.name !== ''">剩余：</span>{{ item.surplus }}
        </div>
        <div class="cont3-forth">
          <van-icon name="success" color="#008B5E" v-if="item.tag" />
        </div>
      </div>
      <!-- <div
      :class="item.surplus === 0 ? 'cont3 bg456' : 'cont3'"
      v-for="(item, index) in huafengTime"
      :key="index"
      @click="changeAppointTime(item, 'huafengTime')"
    >
      <div class="cont3-first">{{ item.name }}</div>
      <div class="cont3-second">{{ item.limit }}</div>
      <div
        class="cont3-third"
        :style="item.surplus === 0 ? 'color: #666666' : ''"
      >
        <span v-if="item.name !== ''">剩余：</span>{{ item.surplus }}
      </div>
      <div class="cont3-forth">
        <van-icon name="success" color="#008B5E" v-if="item.tag" />
      </div>
    </div> -->
    </div>
    <div style="height: 86px;background-color: #f4f5f6;"></div>
    <div
      class="footer-cont"
      @click="timeValue === '请选择预约时间' ? '' : saveTime()"
    >
      <van-button
        type="primary"
        block
        :class="timeValue === '请选择预约时间' ? 'btnStyle3' : 'btnStyle1'"
        >确定</van-button
      >
    </div>
  </div>
</template>
<script>
import moment from "moment";
// import { Toast } from "vant";
export default {
  data() {
    return {
      timeValue: "请选择预约时间",
      timeShow: false,
      hongtaTime: [
        {
          name: "8:00 至 9:00",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "9:00 至 10:00",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "10:00 至 11:30",
          limit: 20,
          surplus: 0,
          tag: false
        },
        {
          name: "11:30 至 13:30",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "",
          limit: "",
          surplus: "",
          tag: false
        },
        {
          name: "13:30 至 15:30",
          limit: 20,
          surplus: 0,
          tag: false
        },
        {
          name: "15:30 至 17:00",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "",
          limit: "",
          surplus: "",
          tag: false
        },
        {
          name: "17:00 至 19:00",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "19:00 至 21:00",
          limit: 20,
          surplus: 5,
          tag: false
        }
      ],
      huafengTime: [
        {
          name: "8:00 至 9:00",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "9:00 至 10:00",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "10:00 至 11:00",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "11:00 至 12:00",
          limit: 20,
          surplus: 0,
          tag: false
        },
        {
          name: "",
          limit: "",
          surplus: "",
          tag: false
        },
        {
          name: "12:00 至 13:30",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "13:30 至 14:30",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "14:30 至 15:30",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "15:30 至 16:30",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "16:30 至 17:30",
          limit: 20,
          surplus: 0,
          tag: false
        },
        {
          name: "",
          limit: "",
          surplus: "",
          tag: false
        },
        {
          name: "17:30 至 19:00",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "19:00 至 20:00",
          limit: 20,
          surplus: 0,
          tag: false
        },
        {
          name: "20:00 至 21:00",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "21:00 至 22:00",
          limit: 20,
          surplus: 5,
          tag: false
        },
        {
          name: "22:00 至 23:00",
          limit: 20,
          surplus: 5,
          tag: false
        }
      ]
    };
  },
  methods: {
    // 确认选择日期
    onConfirmTime(val) {
      console.log(val);
      this.timeValue = moment(val).format("YYYY-MM-DD");
      this.timeShow = false;
    },

    // 选择预约时间段
    changeAppointTime(item, type) {
      if (item.name === "") {
        return false;
      }
      if (item.surplus === 0) {
        // Toast({
        //   message: "该时间段内已约满",
        //   className: "toastEDE"
        // });
        this.$common.mbToastFail(`该时间段内已约满`);
        return false;
      }
      let arr = [];
      if (type === "hongtaTime") {
        arr = this.hongtaTime;
      } else {
        arr = this.huafengTime;
      }
      for (let i = 0; i < arr.length; i++) {
        arr[i].tag = false;
      }
      item.tag = true;
    },

    // 确认选择预约时间
    saveTime() {
      console.log(this.timeValue);
    }
  },
  created() {}
};
</script>
<style lang="less" scoped>
.timeDiv {
  height: 100%;
  width: 100%;
  overflow: auto;
  background-color: #f4f5f6;
  .cont1 {
    line-height: 55px;
    background: #fff;
    font-size: 14px;
    display: flex;
    padding: 0px 15px;
    margin-bottom: 10px;
    .left {
      flex: 1;
    }
    .right {
      flex: 0.5;
      text-align: right;
      font-size: 20px;
    }
  }
  .cont2 {
    background: #fff;
    display: flex;
    font-size: 15px;
    padding: 16px;
    align-items: center;
    &-first {
      flex: 1.1 !important;
      text-align: left !important;
    }
    & > div {
      flex: 1;
      text-align: center;
    }
  }
  .cont3 {
    background: #fff;
    display: flex;
    font-size: 14px;
    padding: 0px 16px 20px;
    align-items: center;
    line-height: 43px;
    padding: 0px 16px;
    height: 43px;
    &-first {
      flex: 1.1;
      text-align: left !important;
    }
    &-second {
      color: #ec3f67;
      flex: 1;
      text-align: center;
    }
    &-third {
      color: #008b5e;
      flex: 1;
      text-align: center;
    }
    &-forth {
      flex: 0.1;
      text-align: center;
    }
  }
  .pd40 {
    padding-bottom: 36px;
  }
  .bg456 {
    background: #f4f5f6;
  }
}
</style>
<style lang="less">
.van-button--round {
  border-radius: 4px;
}
</style>
